import Link, { Props as LinkProps } from 'components/Link';
import Group from 'entities/Group';
import * as React from 'react';

type GroupObj = { name: string; displayName?: string };
type Props = {
  group: Group | GroupObj;
  children: React.ReactNode;
};

class GroupLink extends React.Component<Props & LinkProps> {
  render() {
    const { group, children, ...other } = this.props;

    if ((group as GroupObj).name) {
      const groupObj = group as GroupObj;
      return (
        <Link
          to={`/classes/${groupObj.name}`}
          data-test-selector={`group-link-${groupObj.name}`}
          activeClassName="active"
          {...other}
        >
          {children || groupObj.displayName}
        </Link>
      );
    }

    if ((group as Group).attributes) {
      // $FlowFixMe cast
      const groupEntity = group as Group;
      return (
        <Link to={groupEntity.webUrl()} activeClassName="active" {...other}>
          {children || groupEntity.getName()}
        </Link>
      );
    }

    console.error('Unexpected group type', group);
    return null;
  }
}

export default GroupLink;
